// extracted by mini-css-extract-plugin
module.exports = {"grayBackground":"LoadingComponent_grayBackground__ZmoeN"};